// Временная страница раздела, пока его зона не сделала свою. Колонка как у
// Ленты/Кабинета: заголовок Barlow Condensed 34 и вводный абзац.

import type { ReactNode } from 'react'
import '../ui/ui.css'

export function SectionStub({ title, lead, children }: { title: string; lead?: ReactNode; children?: ReactNode }) {
  return (
    <div className="abx-stub">
      <div className="abx-stub__page">
        <h1 className="abx-stub__title">{title}</h1>
        {lead ? <p className="abx-stub__lead">{lead}</p> : null}
        {children}
      </div>
    </div>
  )
}
